var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("\n<table v-if=\"data.table\" class=\"custom_table\"><thead><tr><th>Наименование</th></tr></thead><tbody><tr v-repeat=\"data.table\"><td>{{* name }}</td><td>{{* code }}</td><td>{{* road }}</td></tr></tbody></table><component is=\"alert\" name=\"stations-list\" data-message=\"{{ data.message }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/stations-list/component.jade
 ** module id = 57
 ** module chunks = 0
 **/